export default __webpack_public_path__ + "static/media/exit.f3dd4994.svg";